<template>
  <div class="table-list">
    <h3
      v-if="heading"
      class="grey"
      v-html="heading"></h3>
    <TableItem
      v-for="(item, key) in sorted"
      :key="key"
      :item="item">
      {{ item.url }}
    </TableItem>
  </div>
</template>

<script>
import TableItem from '@/components/TableItem'

export default {
  name: 'Table',
  components: {
    TableItem
  },
  props: {
    heading: {
      type: String,
      default: null
    },
    content: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      sorted: []
    }
  },
  created() {
    this.sorted = this.content.sort((a, b) => a.year < b.year);
  }
}
</script>

<style lang="scss" scoped>
.table-list {
  padding: $padding--base 0;

  h3 {
    margin-bottom: $gutter--base;
  }

  @include mobile {
    padding: $padding--base-mbl 0;
  }
}
</style>
